import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { LocationsListComponent } from '@app/shared/ui-components/locations-list/locations-list.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'copy-routine-dialog',
	imports: [LocationsListComponent, NgxTolgeeModule, MatButtonModule, MatDialogClose],
	templateUrl: './copy-routine-dialog.component.html',
	styleUrl: './copy-routine-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyRoutineDialogComponent {
	locations = signal<ICMMSLocation[]>([]);
}
